import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { PostauthService } from 'src/app/services/postauth.service';

@Injectable({
  providedIn: 'root'
})
export class DiscountListResolver implements Resolve<boolean> {
  constructor(private postauth: PostauthService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.postauth.listDiscounts();
  }
}
